/**
 * This directive can be used when rendering the GeneralTabs component
 * within a layout that has a dynamically-changing width.
 * The tab slider CSS is injected inline on tab change so this directive
 * will make it dynamic or static accordingly and reactive to the layout.
 *
 * How to use:
 * <GeneralTabs v-dynamic-slider>
 *   .....
 * </GeneralTabs>
 */

import Vue from 'vue';

let dynamicSlider, staticSlider, element;

const initSliders = () => {
  dynamicSlider = element.querySelector('.v-tabs-slider-wrapper');
  staticSlider = dynamicSlider.cloneNode(true);
  staticSlider.classList.add('v-tabs-slider-wrapper--static');
};

const showStaticSlider = () => {
  dynamicSlider.style.display = 'none';
  element.querySelector('.v-tab--active').appendChild(staticSlider);
  staticSlider.style.display = 'block';
};

const showDyanmicSlider = () => {
  staticSlider.style.display = 'none';
  dynamicSlider.style.display = 'block';
};

const onChange = () => {
  showDyanmicSlider();
  setTimeout(showStaticSlider, 300);
};

Vue.directive('dynamic-slider', {
  bind(el, binding, vnode) {
    element = el;
    initSliders();
    showStaticSlider();
    vnode.context.$on('change', onChange);
  },
  unbind(el, binding, vnode) {
    vnode.context.$off('change', onChange);
  }
});
